import { render, staticRenderFns } from "./coaching.vue?vue&type=template&id=219f58b6"
import script from "./coaching.vue?vue&type=script&lang=js"
export * from "./coaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports